import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { GROUP_ORDER } from './sizes';

/** S / M / L group toggle (design: 26 x 24 cells, navy active, disabled greyed). */
export default function SizeToggle({ groups, active, onChange, widgetId }) {
  const { t } = useTranslation();
  return (
    <Box
      role="group"
      aria-label={t('dashboard.edit.size')}
      sx={{ display: 'inline-flex', border: '1px solid #e2e8f0', borderRadius: '6px', overflow: 'hidden', bgcolor: '#fff' }}
    >
      {GROUP_ORDER.map((group) => {
        const enabled = groups.includes(group);
        const selected = active === group;
        return (
          <Box
            key={group}
            component="button"
            type="button"
            data-testid={`widget-${widgetId}-size-${group}`}
            disabled={!enabled}
            onClick={(event) => {
              event.stopPropagation();
              if (enabled) onChange(group);
            }}
            sx={{
              width: 26,
              height: 24,
              border: 0,
              p: 0,
              fontSize: 11.5,
              fontWeight: 700,
              fontFamily: 'inherit',
              cursor: enabled ? 'pointer' : 'default',
              color: selected ? '#fff' : enabled ? '#1a202c' : '#e2e8f0',
              bgcolor: selected ? '#1a365d' : '#fff',
              borderLeft: group === 'S' ? 0 : '1px solid #e2e8f0',
            }}
          >
            {group}
          </Box>
        );
      })}
    </Box>
  );
}
